import { render, staticRenderFns } from "./HeaderMobile.vue?vue&type=template&id=04b153c4&scoped=true"
import script from "./HeaderMobile.vue?vue&type=script&lang=js"
export * from "./HeaderMobile.vue?vue&type=script&lang=js"
import style0 from "./HeaderMobile.vue?vue&type=style&index=0&id=04b153c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b153c4",
  null
  
)

export default component.exports